var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-export-data btnHover",on:{"click":_vm.exportData}},[_c('i',{staticClass:"icon iconfont iconicon_share"}),_c('span',[_vm._v("导出数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }